import { useMutation } from '@tanstack/react-query';
import { lt, showSuccessAlert } from '@mews/framework';
import { Bill, useRepositoryRegistry } from '@mews-commander/data-access';
import { WithAccountId } from '@mews-commander/types';
import { setBills } from '@mews-commander/legacy-entities/src/ducks/bills';
import { fetchAccountById } from '@mews-commander/legacy-entities/src/actions';
import { useCommanderThunkDispatch } from '@mews-commander/utils';

interface MutationParameters {
    billId: string;
    billOwnerId: string;
    associatedAccountId: string | undefined;
    closeDialog: () => void;
    openReviewDialog?: ({ bills, accountId }: { bills: Array<Bill> } & WithAccountId) => void;
}

export const useChangeOpenBillOwner = () => {
    const dispatch = useCommanderThunkDispatch();
    const { bills } = useRepositoryRegistry();
    return useMutation({
        mutationFn: async ({ billId, billOwnerId: ownerId, associatedAccountId }: MutationParameters) =>
            bills
                .update({
                    billUpdates: [
                        {
                            billId,
                            ownerId: { value: ownerId },
                            associatedAccountId: associatedAccountId ? { value: associatedAccountId } : undefined,
                        },
                    ],
                })
                .then(async (result) => {
                    showSuccessAlert({
                        title: lt('ChangeBillOwnerSuccessMessage'),
                    });

                    await dispatch(fetchAccountById({ accountId: ownerId }));

                    return Promise.resolve(result);
                }),
        onSuccess: ({ bills: billsCollection }, { closeDialog, openReviewDialog, billOwnerId }) => {
            if (billsCollection?.length) {
                dispatch(setBills(billsCollection));
            }

            closeDialog();

            if (openReviewDialog && billsCollection?.length) {
                openReviewDialog({ bills: billsCollection, accountId: billOwnerId });
            }
        },
    });
};
